import { render, staticRenderFns } from "./usersubgroup.vue?vue&type=template&id=61dccd3a"
import script from "./usersubgroup.vue?vue&type=script&lang=js"
export * from "./usersubgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports